import { BrandCategory } from './brands';

export const OUTLINED_BRAND_ASSET_ROOT = 'brands-outlined';
export const NO_OUTLINE_BRAND_ASSET_ROOT = 'brands-no-outline';

export const getBrandAssetRootForModel = (model) =>
  model?.name?.endsWith('_Brown')
    ? NO_OUTLINE_BRAND_ASSET_ROOT
    : OUTLINED_BRAND_ASSET_ROOT;

export const getBrandAssetFolderForModel = (model, category) => {
  const root = getBrandAssetRootForModel(model);
  return category === BrandCategory.ALPHANUMERIC_LARGE
    ? `${root}/bolded`
    : root;
};
